import React from 'react';
import InfoTooltip from '../../../common/tooltip/info/index';

const RejectButton = (open, isCancelRequest) => {
  const info = isCancelRequest ? 'rejectCancellationRequest' : 'rejectTravelExpense';

  return (
    <InfoTooltip info={info}>
      <button className="btn btn-xs btn-fill btn-danger" onClick={open}>
        <i className="fa fa-ban" />
      </button>
    </InfoTooltip>
  );
};

export default RejectButton;



// WEBPACK FOOTER //
// ./src/components/actions/reject/button/index.js